import React, { useContext } from "react";
import FuncionesContext from "../../context/FuncionesContext";
import { Link } from "react-router-dom";
import { construirEnlace, extraerTextoPlano } from "../../helper/funciones";
import "./Mensaje.scss";
import BotonCopiar from "../BotonCopiar/BotonCopiar";

export function OMensaje(props) {
  const {
    modalProps,
    configuracion,
    qsBody,
    params = {},
    opciones_de_pantalla,
  } = props;
  const { opciones } = configuracion;
  let { mensaje, className, id_a, id } = opciones;
  const func = useContext(FuncionesContext);

  function convertirBuffer(data) {
    try {
      if (Buffer.isBuffer(data.data) || data.type === "Buffer") {
        const b = Buffer.from(data.data);
        return b.toString("utf-8");
      }
      return data;
    } catch (err) {
      // console.log(err);
    }
  }

  mensaje = convertirBuffer(mensaje);
  const tieneCopy = [opciones.tiene_copiar, opciones.copy].some(
    (valor) => String(valor ?? "").toLowerCase() === "s",
  );
  const textoCopiar = extraerTextoPlano(mensaje);

  const renderContenido = () => {
    if (opciones.enlace_id_a && opciones.enlace_id_a !== "") {
      const enlaceObj = construirEnlace(opciones, opciones);

      if (opciones.target === "modal") {
        return (
          <div
            onClick={() =>
              func.enviarAModal(
                enlaceObj.id_a,
                params,
                { min_width_modal: opciones.min_width_modal },
                Object.assign(qsBody, enlaceObj.params)
              )
            }
            className={className}
            id={id_a}
            style={{ cursor: "pointer" }}
          >
            {mensaje}
          </div>
        );
      }

      return (
        <div id={id}>
          <Link
            to={{
              pathname: `/${enlaceObj.enlace.replace(/^\/+/, "")}`,
              search: enlaceObj.parametros,
            }}
            target={opciones.target}
            style={{ background: "transparent" }}
            className={className}
          >
            {mensajeSwitch(opciones, opciones_de_pantalla)}
          </Link>
        </div>
      );
    }

    return mensajeSwitch(opciones, opciones_de_pantalla);
  };

  return (
    <div className="mensaje-copy-container">
      {tieneCopy && <BotonCopiar texto={textoCopiar} />}
      {renderContenido()}
    </div>
  );
}

function mensajeSwitch(opciones, opciones_de_pantalla) {
  const { componente, className, mensaje, id } = opciones;

  switch (componente) {
    case "colegio_header":
      return (
        <ColegioHeader
          opciones={opciones}
          opciones_de_pantalla={opciones_de_pantalla}
        />
      );
    default:
      return (
        <div
          id={id}
          className={className}
          dangerouslySetInnerHTML={{ __html: mensaje }}
        ></div>
      );
  }
}

const ColegioHeader = ({ opciones, opciones_de_pantalla }) => {
  const rawMensaje = opciones.mensaje ?? "";
  const mensaje =
    typeof rawMensaje === "string" ? rawMensaje : String(rawMensaje);

  const tieneHTML = /<\/?[a-z][\s\S]*>/i.test(mensaje);

  return (
    <>
      <header className="colegio-header">
        <div className="colegio-header-inner">
          <div className="colegio-header-logo">
            <img
              alt="Colegio de Farmacéuticos"
              src="./static/media/logoColegio-old.d9e9daac.png"
            />
          </div>

          <h1 className="colegio-header-title">
            {opciones_de_pantalla.titulo}
          </h1>

          <div className="colegio-header-spacer" />
        </div>
      </header>

      {mensaje.trim() !== "" && (
        <div className="colegio-header-mensaje">
          {tieneHTML ? (
            <div dangerouslySetInnerHTML={{ __html: mensaje }} />
          ) : (
            <p>{mensaje}</p>
          )}
        </div>
      )}
    </>
  );
};